import React from 'react';

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="spinner"></div>
      <p className="loading-text">Cargando dashboard...</p>
    </div>
  );
};

export default LoadingSpinner;